import TextField from "@mui/material/TextField";
import { styled } from "@mui/system";

export const StyledTextField = styled(TextField)(({ theme }) => ({
  "&.MuiTextField-root": {
    boxSizing: "border-box",
    borderRadius: "12px",
    border: "1px solid rgba(0, 0, 0, 0.23)",

    "& .MuiInputBase-root": {
      borderRadius: "12px",
      maxWidth: "3rem",
      height: "3rem",
      "@media (min-width: 400px) and (max-width:600px)": {
        maxWidth: "4rem",
        height: "4rem"
      },
      "@media (min-width: 600px)": {
        maxWidth: "6rem",
        height: "5.3rem"
      }
    },
    "& input": {
      padding: "0.6rem",
      textAlign: "center",
      fontSize: "1.25rem",
      fontWeight: 500,
      lineHeight: "1.75rem",
      fontFamily: "Rakbank Sans, sans-serif",
      [theme.breakpoints.up("sm")]: {
        fontSize: "2rem",
        lineHeight: "2.5rem"
      }
    },
    "& fieldset": {
      border: "none"
    },
    "&:focus-visible": {
      outline: "none !important"
    }
  }
}));
